import type { VillageIncidentChartMode } from "../model/villageIncidentCharts";

type ChartModeToggleProps = {
  mode: VillageIncidentChartMode;
  chartTitle: string;
  controlsId: string;
  onToggle: () => void;
};

export function ChartModeToggle({ mode, chartTitle, controlsId, onToggle }: ChartModeToggleProps) {
  const nextMode = mode === "bar" ? "pie" : "bar";

  return (
    <button
      type="button"
      className="secondary-button is-inline village-incident-chart-card__toggle"
      onClick={onToggle}
      aria-controls={controlsId}
      aria-pressed={mode === "pie"}
      aria-label={`Switch ${chartTitle} to ${nextMode} chart`}
    >
      <span className="village-incident-chart-card__toggle-icon" aria-hidden="true">
        {mode === "bar" ? (
          <svg viewBox="0 0 24 24" role="presentation">
            <path d="M12 3a9 9 0 1 0 9 9h-9z" fill="currentColor" />
          </svg>
        ) : (
          <svg viewBox="0 0 24 24" role="presentation">
            <rect x="4" y="12" width="4" height="8" fill="currentColor" />
            <rect x="10" y="8" width="4" height="12" fill="currentColor" />
            <rect x="16" y="5" width="4" height="15" fill="currentColor" />
          </svg>
        )}
      </span>
      <span>{mode === "bar" ? "Pie" : "Bar"}</span>
    </button>
  );
}
